import { Link } from 'react-router-dom';
import { featuredAnime } from '@/mocks/animeData';

export default function FeaturedAnime() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选推荐</h2>
            <p className="text-sm text-foreground-600">编辑团队精心挑选的高质量成人动漫作品</p>
          </div>
          <Link
            to="/category/story"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredAnime.map((anime) => (
            <Link
              key={anime.id}
              to={`/article/${anime.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[2/3] overflow-hidden">
                <img
                  src={anime.image}
                  alt={anime.title}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md">
                  {anime.rating}
                </div>
                {anime.tags[0] && (
                  <div className="absolute bottom-2 left-2">
                    <span className="bg-background-50/90 text-foreground-800 text-xs px-2 py-0.5 rounded-full">
                      {anime.tags[0]}
                    </span>
                  </div>
                )}
              </div>
              <div className="p-3">
                <h3 className="font-heading text-sm text-foreground-900 mb-1 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {anime.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {anime.description}
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-xs text-foreground-400">{anime.year}</span>
                  <span className="text-xs text-accent-500 font-medium">{anime.tags[1]}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}